module.exports = __webpack_public_path__ + "img/img57.0cec643e.png";